import { MTableToolbar } from 'material-table'

export default (props) => (
    <div className="materialTableToolbar">
        <MTableToolbar {...props} />
    </div>
)
